import { GeoService } from 'app/services/GeoService';
import { getGeoCoderLatLong } from 'app/services/google-maps.service';
import React, { Component } from 'react';
import { MapState, MapProps, DirectionsWaypoint, DirectionLocation } from './map.type';

export class GoogleMap extends Component<MapProps, MapState> {

  private markerLocations: any = [];
  private renderObjects: any = [];

  private readonly mapContainer = React.createRef<HTMLDivElement>();

  constructor(props: MapProps) {
    super(props);
    this.state = {
      isMapReady: false,
      map: null,
      google: null,
      directionsService: null,
      directionsRenderer: null,
    };
  }

  createMarker = (props: any) => {
    const marker = new google.maps.Marker({
      position: props.latlng,
      map: props.map,
      icon: props.icon,
    });

    const originInfoWindow = new google.maps.InfoWindow({
      content: props.address,
    });
    google.maps.event.addDomListener(marker, 'click', function () {
      originInfoWindow.open(props.map, marker);
    });
    return marker
  }

  public getIconName = (type: string) => {
    switch (type) {
      case 'P':
        return 'origin';
      case 'D':
        return 'destination';
      case 'NFR':
        return 'stops-green';
      default:
        return 'stops';
    }
  }

  renderChildren = () => {

    const {
      bounds: routeBounds,
      waypoints,
      disableDefaultUI,
      mapTypeControl,
      scaleControl,
      streetViewControl,
      zoomControl,
      fullscreenControl,
      isMyload,
      isLimitedZoom
    } = this.props;


    if (this.mapContainer?.current) {
      let map = new google.maps.Map(this.mapContainer.current, {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoom: 14,
        disableDefaultUI,
        mapTypeControl,
        scaleControl,
        streetViewControl,
        zoomControl,
        fullscreenControl,
        maxZoom: (isLimitedZoom ? GeoService.MaxZoomLevel : undefined)
      });

      let bounds = new google.maps.LatLngBounds();
      routeBounds.map(async (item: any) => {
        const waypointsData = waypoints.map((data: any) => data.location);
        this.markerLocations = [item.origin, ...waypointsData, item.destination];
        const originCity = `${item.origin.city}, ${item.origin.state}`;
        const origin: any = item.origin?.latLng ? item.origin.latLng : await getGeoCoderLatLong(originCity);
        const destinationCity = `${item.destination.city}, ${item.destination.state}`;
        const destination: any = item.destination?.latLng ? item.destination.latLng : await getGeoCoderLatLong(destinationCity);
        let serviceWaypoints: { location: string; stopover?: boolean }[] = [];
        if (waypoints) {
          serviceWaypoints = waypoints.map(
            (item: DirectionsWaypoint, index: number) => {
              const lat: any =
                (item?.location?.latLng?.lat) ||
                0;
              const lng: any =
                (item?.location?.latLng?.lng) ||
                0;

              if (lat && lng) {
                return {
                  location: new google.maps.LatLng(lat, lng),
                  stopover: item.stopover,
                };
              } else if (!isMyload) {
                return {
                  location: `${item.location.city}, ${item.location.state}`,
                  stopover: item.stopover,
                };
              }
            }
          );
        }
        const newRoute = ({
          origin: new google.maps.LatLng(origin.lat, +origin.lng),
          destination: new google.maps.LatLng(+destination.lat, +destination.lng),
          waypoints: serviceWaypoints,
          travelMode: google.maps.TravelMode.DRIVING,

        });
        const address = [
          {
            address: originCity,
            latlng: origin,
            icon: `assets/images/${this.getIconName(item.origin.locationType)}.svg`,
          },
          {
            address: destinationCity,
            latlng: destination,
            icon: `assets/images/${this.getIconName(item.destination.locationType)}.svg`,
          },
        ];
        const markers: any = address.map(data => this.createMarker({ ...data, map }));
        this.clearRenderObjects();
        new google.maps.DirectionsService().route(newRoute, (body, status) => {
          let display = new google.maps.DirectionsRenderer({
            map: map,
            directions: body,
            suppressMarkers: true,
            preserveViewport: true
          });


          const routes: any[] = body ? body.routes[0].legs : [];
          const otherMarkers: any = [];
          if (routes.length > 1) {
            routes.forEach((item: any, index: number) => {
              if (index !== 0 && index < this.markerLocations.length) {
                const locationResponse = this.markerLocations[index];
                const address = `${locationResponse.city}, ${locationResponse.state}`;
                const locationType = locationResponse.locationType;
                otherMarkers.push(this.createMarker(
                  {
                    address,
                    latlng: item.start_location,
                    map,
                    icon: `assets/images/${this.getIconName(locationType)}.svg`,
                  }
                ));
              }



            });

          }
          const listMarkers = [...markers, ...otherMarkers];
          for (let i = 0; i < listMarkers.length; i++) {
            if (listMarkers[i].getVisible()) {
              bounds.extend(listMarkers[i].getPosition());
            }
          }
          map.fitBounds(bounds);
          display.setMap(map);
          display.setDirections(body);
          google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
            let currCenter = map.getCenter();
            google.maps.event.trigger(map, 'resize');
            map.setCenter(currCenter);

          });
          this.renderObjects.push(display);
        });
      });
    }
    return <></>
  }

  clearRenderObjects() {
    for (let i in this.renderObjects) {
      this.renderObjects[i].setMap(null);
      this.renderObjects[i].setDirections({ routes: [] });
    }
  }

  public addMarkerToTheLocation = (
    locationName: string
  ): { locationType: string; index: number; city: string; state: string } => {
    let locationResponse: {
      locationType: string;
      index: number;
      city: string;
      state: string;
    } = {
      locationType: '',
      index: -1,
      city: '',
      state: '',
    };

    if (this.markerLocations) {
      const locationParts: string[] = locationName.split(',');
      let locationMatched = false;
      this.markerLocations.forEach(
        (location: DirectionLocation, index: number) => {
          if (locationMatched) {
            return false;
          }
          let name: string = location.locationName;
          name = name.toUpperCase();
          let countSubstr = 0;
          locationParts.forEach((str: string) => {
            if (name.includes(str.toUpperCase())) {
              countSubstr++;
            }
          });

          if (1 <= countSubstr && !this.markerLocations[index].isMarkerAdded) {
            this.markerLocations[index].isMarkerAdded = true;
            locationResponse = {
              locationType: this.markerLocations[index].locationType,
              index,
              city: this.markerLocations[index].city!,
              state: this.markerLocations[index].state!,
            };
            locationMatched = true;
          }
        }
      );
    }

    return locationResponse;
  };

  render() {
    const { className } = this.props;
    return (
      <React.Fragment>
        <div
          style={{
            height: '100%',
            width: '100%',
            translate: 'translate3d(0)',
            opacity: 1,
            position: 'relative'
          }}
          ref={this.mapContainer}
          className={className}
        />
        {this.renderChildren()}
      </React.Fragment>
    );
  }

}